import Carousel from 'react-bootstrap/Carousel';
// import slides from './SlideData.json'
import "./CompanySlider.css";

const companySlideArray = [
  {
    id: 1,
    image: require('../images/ComponentImg/hlz-building.png'),
    name: 'HLZ Company Building',
    title: 'HLZ Company Building',
    description: '合利资科技 广东东莞市大岭山xx工业区 A栋-5楼 & D栋-4楼',
    link: 'https://www.hlztouch.com'
  },
  {
    id: 2,
    image: require('../images/ComponentImg/hlz-lobby.png'),
    name: 'Office Lobbby',
    title: 'Office Lobbby',
    description: '合利资科技接待大厅 @园区 D栋-4楼',
    link: 'https://www.hlztouch.com'
  },
  {
    id: 3,
    image: require('../images/ComponentImg/hlz-office.jpg'),
    name: 'Engineering Department Office',
    title: 'Engineering Department Office',
    description: '合利资科技办公室 @园区 D栋-4楼',
    link: 'https://www.twitter.com'
  }
]

export function CompanySlider() {
  return (
    <section id='companyslider' className='companyslider-block'>
      <Carousel controls={true}> {
        companySlideArray.map(slide => {
          return (
            <Carousel.Item key={slide.id}>
              <img className='d-block' src={slide.image} alt={slide.id} />
              {/* <img style={{ height:'80vh' }} className='d-block w-80' src={slide.image} alt={slide.id} /> */}
              <Carousel.Caption>
                <h2>{slide.title}</h2>
                <h3>{slide.description}</h3>
                <a className='btn btn-primary' href={slide.link}> Detail <i className='fas fa-chevron-right' /> </a>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })
      } </Carousel>
    </section >
  );
}

// export default companySlider;